export default __webpack_public_path__ + "static/media/library.ebd6c98f.png";